import { message } from "antd";
import {
  queryList,
  dataManageList,
  noticeDelete,
  recall,
  queryStatusList,
  publish,
  republish,
  addReceiver,
  remind,
} from "../../../../services/notice/outbox";

const initState = () => {
  return {
    statusList: [],
    /**
     * 学校或者区县通知列表
     * content: [
     *   {
     *    orgCount: '', // 接收学校数量
     *    fileCount: '', // 附件数
     *    id: '', // 消息id
     *    notReadCount: '', // 未读数
     *    readCount: '', // 已读数
     *    sendState: '', // 发送状态
     *    sendTime: '', // 发送时间
     *    title: '', // 标题
     *    'type': [], // 消息类型，1=学校内部发送，2=区县内部发送，3=区县发学校 pc端暂时没用
     *    subContent: '', // 消息体的前20个字
     *   },
     *  ],
     *  page: '',
     *  pageSize: '',
     *  totalElements: '',
     *  totalPage: '',
     */
    list: [],
    queries: {
      sentState: "",
      subContent: ""
    }, // 搜索查询条件

    // 分页信息
    pageInfo: {
      page: 1,
      pageSize: 10,
      totalElements: 1,
      totalPages: 1
    },
    // 加载信息
    spinProps: {
      spinning: false,
      tip: "加载中..."
    }
  };
};

export default {
  namespace: "noticeOutbox",

  state: initState(),

  effects: {
    // 获取列表信息
    *fetchList({ payload }, { call, put, select }) {
      try {
        // 页面定时刷新不需要加载中动画
        const { reFresh = true, pageType } = payload;
        if (reFresh) {
          yield put({
            type: "save",
            payload: {
              spinProps: {
                spinning: true,
                tip: "加载中..."
              }
            }
          });
        }

        // 判断上次操作是否为查询  是则 获取数据的page字段改为 1
        const { isSearch, sentState } = yield select(state => state.noticeOutbox);

        let params = { ...payload, sentState };

        if (isSearch !== false) {
          params = Object.assign({}, params, {
            page: 1
          });
        }
        const [response, statusList] = yield [
          call(pageType === "dataManage" ? dataManageList : queryList, params),
          call(queryStatusList)];

        const { content, page, pageSize, totalElements, totalPages } = response;
        yield put({
          type: "save",
          payload: {
            statusList,
            list: content,
            pageInfo: {
              page,
              pageSize,
              totalElements,
              totalPages
            },
            isSearch: false,
            sentState,
            spinProps: {
              spinning: false
            }
          }
        });
      } catch (error) {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: false
            }
          }
        });
      }
    },
    *fetchSearch({ payload }, { call, put }) {
      try {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: true,
              tip: "加载中..."
            }
          }
        });

        const { pageType } = payload;

        const response = yield call(pageType === "dataManage" ? dataManageList : queryList, payload);

        const { content, page, pageSize, totalElements, totalPages } = response;
        yield put({
          type: "save",
          payload: {
            list: content,
            pageInfo: {
              page,
              pageSize,
              totalElements,
              totalPages
            },
            spinProps: {
              spinning: false
            }
          }
        });
      } catch (error) {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: false
            }
          }
        });
      }
    },
    *fetchDel({ payload }, { call, put, select }) {
      try {
        const {nameImportFlag, pageType} = payload;
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: true,
              tip: "删除中..."
            }
          }
        });
        yield call(noticeDelete, payload);
        message.success("删除成功");
        const { pageInfo, queries } = yield select(state => state.noticeOutbox);
        const { page, pageSize } = pageInfo;
        yield put({
          type: "fetchSearch",
          payload: {
            page,
            pageSize,
            pageType,
            ...queries,
            nameImportFlag,
          }
        });

        return Promise.resolve();
      } catch (error) {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: false
            }
          }
        });
        return Promise.reject();
      }
    },
    *fetchRequest({ payload }, { call, put, select }) {
      try {
        const {nameImportFlag, pageType} = payload;

        const fetchMap = {
          "recall": { request: recall, tip: "撤回" },
          "publish": { request: publish, tip: "发布" }, // 立即发布
          "rePublish": { request: republish, tip: "发布" }, // 重新发布
          "addReceiver": { request: addReceiver, tip: "补发" },
          "remind": { request: remind, tip: "提醒" }
        };

        const { fetchType } = payload;
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: true,
              tip: `${fetchMap[fetchType].tip}中...`
            }
          }
        });

        yield call(fetchMap[fetchType].request, payload);
        message.success(`${fetchMap[fetchType].tip}成功`);

        const { pageInfo, queries } = yield select(state => state.noticeOutbox);
        const { page, pageSize } = pageInfo;

        yield put({
          type: "fetchSearch",
          payload: {
            page,
            pageSize,
            ...queries,
            pageType,
            nameImportFlag,
          }
        });

        return Promise.resolve();
      } catch (error) {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: false
            }
          }
        });
        return Promise.reject();
      }
    }
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
    resetState(state, { payload }) {
      return {
        ...initState(),
        ...payload,
      };
    }
  }
};
